import { useEffect, useState } from "react";
import { GET_NEWS } from "../../../helpers/graphqlQueries";


export function useAirtable(apolloClient){
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [componentOffset, setComponentOffset] = useState(0)
  const [data, setData] = useState([])
  const [lastPage, setLastPage] = useState(false)
  const [firstCall, setFirstCall] = useState(true)

  useEffect( () => {
    didMount()
  }, [])
  
  const didMount = async ()=>{
    if (firstCall) {
      let records = await getData()();
      setData(records)
      setFirstCall(false)
    }
  }

  const nextPage = async (searchText, category, audience, mediaType) => {
    if (!lastPage) {
      const records = await getData(componentOffset+10)(searchText, category, audience, mediaType);
      setData([...data, ...records]);
      if(records?.length<10)setLastPage(true);
      setComponentOffset(r=>r+10);
    }
  }

  const fetch = async (searchText, category, audience, mediaType) => {
    const records = await getData()(searchText, category, audience, mediaType);
    setData(records)
    if(records?.length<10){
      setLastPage(true);
    }else{
      setLastPage(false);
    }
    setComponentOffset(0);
  }

  const getData = (offset = 0) => async (searchText = '', category = '', audience = '', mediaType = '') => {
    setLoading(true)
    try {
      const result = await apolloClient.query({query: GET_NEWS, variables: {
        offset,
        searchText: `%${searchText}%`,
        category: `%${category}%`,
        audience: `%${audience}%`,
        mediaType: `%${mediaType}%`,
      }})
      return result.data?.articles;
    } catch (error) {
      console.log(error)
      setError(error)
    }
    setLoading(false)
  }

  return [nextPage, fetch, { loading, data, error, lastPage }]
}
